export default function TeachersSection() {
  const teachers = [
    {
      name: '김선희 선생님',
      specialty: '패턴 제작 전문',
      experience: '25년 경력',
      description: '정교한 패턴 제작과 의복 구조 설계의 전문가입니다. 복잡한 디자인도 완벽하게 구현합니다.',
      image: 'https://public.readdy.ai/ai/img_res/0ade35c2024ddb4744e3fe16d71a4295.jpg',
    },
    {
      name: '박미경 선생님',
      specialty: '봉제 기술 전문',
      experience: '30년 경력',
      description: '산업용 재봉틀부터 특수 봉제까지, 모든 봉제 기술을 섭렵한 장인입니다.',
      image: 'https://readdy.ai/api/search-image?query=skilled%20female%20korean%20seamstress%20operating%20industrial%20sewing%20machine%20in%20bright%20workshop%20concentrated%20professional%20craftswoman%20working%20on%20fabric%20natural%20daylight%20authentic%20workspace%20sustainable%20fashion%20artisan%20portrait%20photography&width=600&height=700&seq=daygreen-teacher-2&orientation=portrait',
    },
    {
      name: '이정숙 선생님',
      specialty: '마감 처리 전문',
      experience: '20년 경력',
      description: '섬세한 마감 처리로 제품의 완성도를 높이는 디테일의 달인입니다.',
      image: 'https://readdy.ai/api/search-image?query=experienced%20female%20korean%20seamstress%20doing%20detailed%20finishing%20work%20on%20garment%20in%20bright%20workshop%20careful%20professional%20craftswoman%20hand%20stitching%20natural%20lighting%20authentic%20workspace%20sustainable%20fashion%20artisan%20portrait%20photography&width=600&height=700&seq=daygreen-teacher-3&orientation=portrait',
    },
    {
      name: '최영희 선생님',
      specialty: '특수 소재 전문',
      experience: '18년 경력',
      description: '기능성 소재와 특수 원단 작업의 전문가로, 까다로운 소재도 완벽하게 다룹니다.',
      image: 'https://public.readdy.ai/ai/img_res/edited_ee9cb4844451a3951fb592bd0df9b314_ff7c80e2.jpg',
    },
  ];

  return (
    <section className="py-32 px-6 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-stone-800 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            봉제 선생님
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
            우리는 기술을 가진 분들을 "선생님"이라 부릅니다.
            <br />
            오랜 시간 축적된 경험과 노하우를 존중하며, 함께 성장합니다.
          </p>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mt-8"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teachers.map((teacher, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={teacher.image}
                  alt={teacher.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-emerald-600 text-white px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
                  {teacher.experience}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-stone-800 mb-2" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                  {teacher.name}
                </h3>
                <p className="text-emerald-700 font-semibold mb-4 text-base">
                  {teacher.specialty}
                </p>
                <p className="text-stone-600 leading-relaxed text-sm">
                  {teacher.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-emerald-50 border-l-4 border-emerald-600 p-10 rounded-r-2xl">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-600 rounded-full flex-shrink-0">
              <i className="ri-user-heart-line text-3xl text-white"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-stone-800 mb-4" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                기술 인력 소개
              </h3>
              <p className="text-stone-700 leading-relaxed text-base">
                Daygreen은 현재 12명의 봉제 선생님과 함께하고 있습니다. 각자의 전문 분야에서 최고의 기술력을 보유하고 있으며, 
                서로의 경험을 나누며 함께 성장하고 있습니다. 기술은 단순한 노동이 아닌, 한 사람의 삶이 담긴 소중한 자산입니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}